let hostname = window.location.origin
let urlMap = {
  BASE_URL: `${hostname}/api-v2`
}

let devMap = {
  // BASE_URL: 'http://192.167.6.41:7102/api-v2', // 测试请求环境
  // BASE_URL: 'http://192.167.6.43:19000', // 测试请求环境
  // ------------------------------------------------
  // BASE_URL: 'http://192.167.6.108:19000', // 周勇
  BASE_URL: 'http://192.167.6.153:19000' // 向本乾
  // BASE_URL: 'http://192.167.6.169:19000', // 陈一凡
  // BASE_URL: 'http://192.167.6.132:19000', // 周茂雄
  // BASE_URL: 'http://192.167.6.184:19000', // 胡晋源
  // BASE_URL: 'http://192.167.6.224:19000', // 郝瑞强
  // BASE_URL: 'http://192.167.6.73:7000', // 郝瑞强
}

// 请求地址
// eslint-disable-next-line no-undef
// if (hostname === 'http://localhost:9528') {
//   devMap.BASE_URL = 'http://192.167.6.41:7102/api-v2'
// }
export const BASE_URL = process.env.NODE_ENV === 'development' ? devMap.BASE_URL : urlMap.BASE_URL

